import React, { useState } from "react";
import cls from "./PageWrapper.module.scss";
import cx from "classnames";
import Loading from "./Loading";
import noop from "common/utils/noop";
import Header from "./Header";

export const LoadingContext = React.createContext<{ setLoading: React.Dispatch<React.SetStateAction<boolean>> }>({
  setLoading: noop,
});

const PageWrapper: React.FC<{ className?: string }> = ({ className, children }) => {
  const [isLoading, setLoading] = useState<boolean>(false);

  return (
    <div className={cx(cls.PageWrapper, className)}>
      <LoadingContext.Provider value={{ setLoading }}>
        {isLoading ? <Loading /> : <Header />}
        {/* PageWrapper__content--hidden just hide components to keep local states on  */}
        <div className={cx(cls.PageWrapper__content, { [cls.hidden]: isLoading })}>
          {React.Children.toArray(children)}
        </div>
      </LoadingContext.Provider>
    </div>
  );
};

export default PageWrapper;
